import { render, staticRenderFns } from "./collectIDsModal.vue?vue&type=template&id=3bc539d2&scoped=true"
import script from "./collectIDsModal.vue?vue&type=script&lang=js"
export * from "./collectIDsModal.vue?vue&type=script&lang=js"
import style0 from "./collectIDsModal.vue?vue&type=style&index=0&id=3bc539d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc539d2",
  null
  
)

export default component.exports